import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';

const CampaignSearch = React.lazy(
  () => import('components/Campaign/Search/Search'),
);

function ScreensCampaignList() {
  return (
    <BaseLayout>
      <DocumentTitle>Campaign List</DocumentTitle>
      <Suspense fallback={<UILoader />}>
        <CampaignSearch />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensCampaignList;
